import { render, staticRenderFns } from "./BasicCardContent.vue?vue&type=template&id=5fc0326c&scoped=true&"
import script from "./BasicCardContent.vue?vue&type=script&lang=js&"
export * from "./BasicCardContent.vue?vue&type=script&lang=js&"
import style0 from "./BasicCardContent.vue?vue&type=style&index=0&id=5fc0326c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0326c",
  null
  
)

export default component.exports